/*!
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

/**
 * Symbol used to retain generic type information when it would otherwise be lost.
 */
export declare const ɵɵTYPE: unique symbol;

/**
 * Symbol used to indicate that a value is a field tree.
 */
export const FIELD_TREE: unique symbol = /* @__PURE__ */ Symbol('FIELD_TREE');
